import React, { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Checkbox, Empty } from 'antd';
import cn from 'classnames';
import ColorCheckbox from '../ColorCheckbox/ColorCheckbox';
import CheckboxLabel from './components/CheckboxLabel/CheckboxLabel';
import DispexButton from '../../../../components/DispexButton/DispexButton';
import { states } from '../../constants/states';
import {
  setWorkers,
  setCalendarData,
} from '../../store/actions/calendarActions';
import styles from './CalendarWorkers.module.scss';

const CalendarWorkers = forwardRef(
  ({ className, showAllWorkers, onShowAllWorkersClick, ...props }, ref) => {
    let checked = 0;
    const { workers, calendarData, state } = useSelector(
      (state) => state.newCalendarStore
    );

    const dispatch = useDispatch();

    const handleAllCheckboxChange = (e) => {
      const updatedWorkers = workers.map((worker) => {
        worker.checked = e.target.checked;

        return worker;
      });

      const updatedCalendarData = calendarData.map((item) => {
        item.tasks.forEach((task) => (task.visible = e.target.checked));

        if (item.daylongTasks) {
          item.daylongTasks.forEach(
            (task) => (task.visible = e.target.checked)
          );
        }

        return item;
      });

      dispatch(setWorkers(updatedWorkers));
      dispatch(setCalendarData(updatedCalendarData));
    };

    const checkboxes = workers
      .sort((a, b) => b.requestCount - a.requestCount)
      .map((worker) => {
        if (worker.checked) {
          checked++;
        }

        return (
          <ColorCheckbox
            entity={worker}
            key={worker.id}
            className={styles.checkbox}
          >
            <CheckboxLabel worker={worker} />
          </ColorCheckbox>
        );
      });

    return (
      <div
        {...props}
        ref={ref}
        className={cn(styles.checkboxesContainer, className)}
      >
        {!checkboxes.length ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <>
            <Checkbox
              indeterminate={checked && checked < checkboxes.length}
              checked={checked === checkboxes.length}
              onChange={handleAllCheckboxChange}
              className={styles.allCheckbox}
            >
              Все
            </Checkbox>
            {checkboxes}
          </>
        )}
        {state !== states.viewTasks && (
          <DispexButton
            className={styles.workersBtn}
            onClick={onShowAllWorkersClick}
          >
            {showAllWorkers
              ? 'Данные по исполнителю из заявки'
              : 'Данные по всем исполнителям'}
          </DispexButton>
        )}
      </div>
    );
  }
);

export default CalendarWorkers;
